import React from 'react';
import { format } from 'date-fns';
import { Status, Tooltip } from '../../../components';
import { t } from 'i18next';

const columns = [
	{
		Header: t('user'),
		accessor: 'email',
	},
	{
		Header: t('nickname'),
		accessor: 'nickname',
	},
	{
		Header: t('createdAt'),
		accessor: 'createdAt',
		Cell: ({ value }: { value: any }) => {
			return format(new Date(value), 'dd MMM yyyy');
		},
	},
	{
		Header: t('isAdmin'),
		accessor: 'isAdmin',
		Cell: ({ value }: { value: any }) => {
			return value ? 'Si' : 'No';
		},
	},
	{
		Header: t('institution'),
		canSort: false,
		accessor: 'doctor.institution.name',
		Cell: ({ value }: any) => (
			<Tooltip
				position='top'
				withIcon={false}
				text={value}
			>
				<span className='max-w-[200px] cursor-pointer truncate relative block'>
					{value}
				</span>
			</Tooltip>
		),
	},
	{
		Header: t('patients'),
		accessor: 'doctor',
		Cell: ({ value }: { value: any }) => {
			return value?.patientsQty || '';
		},
	},
	{
		Header: t('status'),
		accessor: 'isActive',
		Cell: ({ value }: { value: any }) => (
			<Status
				value={value ? 'Active' : 'Inactive'}
				color={value ? 'green' : 'red'}
			/>
		),
	},
];

export default columns;
